import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import {routes} from "@/route";
import {store} from "@/store/store";
import moment from "moment";
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);

require('./store/subscriber')


const dateFormat = (date) => date ? moment(date).format('DD-MM-YYYY') : '';
Vue.filter('dateFormat', dateFormat);

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes

});

import VueNotifications from 'vue-notifications'
import Swal from 'sweetalert2'



// eslint-disable-next-line no-unused-vars
function toast ({title, message, type, timeout, cb}) {

    switch (type) {
        case VueNotifications.types.warn:
            type = 'warning';
            break;
        case VueNotifications.types.success:
            type = 'success';
            break;
        case VueNotifications.types.error:
            type = 'error';
            break;
        case VueNotifications.types.info:
            type = 'info';
            break;
        default:
            type = 'alert'
            break;

    }
    return Swal.fire({title, text: message, icon: type, confirmButtonText: 'OK', toast: false})
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}

Vue.use(VueNotifications, options)


Vue.config.productionTip = true


store.dispatch('auth/attempt', {
    token: localStorage.getItem('token'),
    refresh_token: localStorage.getItem('refresh_token')
}).then(() => {
        new Vue({
            vuetify,
            router,
            store,
            render: h => h(App)
        }).$mount('#app')


    }
);

router.beforeEach((to, from, next) => {

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters['auth/authenticated']) {
            next()
            return
        }
        next('/sign-in')
    }
    next()
})



